var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"zi-spacer",style:({ marginLeft: _vm.marginLeft,  marginTop: _vm.marginTop })})}
var staticRenderFns = []

export { render, staticRenderFns }